import MultipleSelect from '../../../component/MultipleSelect';
import { useSnackbar } from '../../../context/SnackBarContext';
// import { Button, Select, Space } from 'antd';
import LoaderButton from '../../../component/LoaderButton';
import { useState } from 'react';

export const PurchaseOrderForm = ({
    setFormData,
    formData,
    setModalOpen,
    color,
    updateFunc,
    tableData,
    setColor,
    setTableData
}) => {
    const { showError } = useSnackbar();
    const [col, setCol] = useState("")

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSaveButton = () => {
        setModalOpen(true)
    }

    const optionsDelivery = [
        { name: 'Home' },
        { name: 'Office' },
        { name: 'Pickup Point' },
    ]

    const handleChooseStyle = () => {
        if (!(formData.issueQuantity).trim()) {
            showError("Please enter the Issue Quantity before selecting a style name.")
            return
        }
        updateFunc({ isProductDrawerOpen: true })
    }

    //  total
    let total = tableData.item.reduce((sum, item) => {
        const itemTotal = parseFloat(item.total) || 0;
        return sum + itemTotal;
    }, 0);

    total = Math.round(total);

   const handleAddMoreColor = () => {
    if (!tableData.item[0].item_name.trim()) {
        showError("First Select Style Name");
        return;
    }

    if (!col.trim()) {
        showError("Please enter a color");
        return;
    }

    if (color.includes(col.trim().toLowerCase())) {
        showError("This color is already added");
        return;
    }

    const newColor = col.trim().toLowerCase();
    const updatedColors = [...color, newColor];
    setColor(updatedColors);

    setTimeout(() => {
        setTableData((prevData) => ({
            ...prevData,
            totalColor: updatedColors.length
        }));
    }, 300);

    setCol('');
};


    return (
        <div>
            <div className="flex justify-between items-center mb-4 bg-[#f4f5f7] pb-3 md:px-0 px-3">
                <h2 className="md:text-[28px] text-[20px] font-bold text-gray-800">Purchase Order</h2>
                <button
                    onClick={() => handleSaveButton()}
                    className="md:px-4  px-2 md:py-2 py-1  bg-gray-800 text-white border-gray-400 border rounded hover:bg-black">
                    Save
                </button>
            </div>
            <div className="md:px-5 px-2">
                <div className="flex md:flex-row flex-col justify-between pt-3">
                    <div>
                        <p className="font-bold text-gray-800 text-[16px]">BUYER : AMBER SILK MILLS</p>
                    </div>

                    <div className='flex justify-end mr-15'>
                        <div className="flex flex-row justify-center items-center mb-4">
                            <p className="text-gray-700 mr-2">Total :</p>
                            <span className="text-gray-700 text-[24px] font-bold ">₹{total || "0.00"}</span>
                        </div>
                    </div>

                </div>

                <div>
                    <button
                        onClick={handleChooseStyle}
                        className="md:px-4  px-2 md:py-2 py-1  bg-gray-800 text-white border-gray-400 border rounded hover:bg-black">
                        Choose Style Name
                    </button>
                </div>

                <div>
                    <div className="grid md:grid-cols-6 flex-wrap gap-4 mb-6 max-w-[1000px] mt-5">
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">Supplier</label>
                            <input
                                type="text"
                                name="supplier"
                                value={formData.supplier}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Supplier"
                            />
                        </div>
                        <div className="mb-4">
                            <label className="block text-sm font-bold text-gray-700 mb-2">SIZE </label>
                            <input
                                type="text"
                                name="size"
                                placeholder="Size"
                                value={formData.size}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">Fabricator</label>
                            <input
                                type="text"
                                name="fabricator"
                                value={formData.fabricator}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Fabricator"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">STYLE NO</label>
                            <input
                                type="text"
                                name="styleNo"
                                value={formData.styleNo}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Style No"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">Style Name</label>
                            <input
                                type="text"
                                label="Style Name"
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                value={formData.styleName}
                                onChange={handleChange}
                                name="styleName"
                                placeholder="Style Name"
                                disabled

                            />
                        </div>

                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">REMARKS</label>
                            <input
                                type="text"
                                name="remarks"
                                value={formData.remarks}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Remarks"
                            />
                        </div>
                    </div>

                    <div className="grid md:grid-cols-5 flex-wrap gap-4 mb-6 max-w-[1000px] mt-4">
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">ORDER NO</label>
                            <input
                                type="text"
                                name="orderNo"
                                value={formData.orderNo}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Order No"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">DATED *</label>
                            <input
                                type="date"
                                name="dated"
                                value={formData.dated}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Select Date"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">ORDER DATE *</label>
                            <input
                                type="date"
                                name="deliveryDate"
                                value={formData.deliveryDate}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Select Order Date"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2 uppercase">Delivery At</label>
                            <MultipleSelect
                                label="Delivery At"
                                options={optionsDelivery}
                                value={formData.deliveryAt}
                                onChange={handleChange}
                                name="deliveryAt"
                                placeholder="Delivery At"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2">ISSUE QUANTITY*</label>
                            <input
                                type="number"
                                name="issueQuantity"
                                value={formData.issueQuantity}
                                onChange={handleChange}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Issue Quantity"
                            />
                        </div>
                    </div>

                    <div className='mb-6 flex items-end gap-5'>
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-2"> COLOR</label>
                            <input
                                type="text"
                                name="col"
                                value={col}
                                onChange={(e) => setCol(e.target.value)}
                                className="w-full border p-2 rounded focus:ring-blue-500 focus:border-blue-500"
                                placeholder="Add color"
                            />
                        </div>

                        {/* <button></button> */}
                        <LoaderButton label={"Add More Color"} isLoading={false} handleClick={handleAddMoreColor} />

                        {color.length > 0 && (
                            <div className="flex flex-wrap gap-2 mt-2">
                                <span className='font-semibold mr-2'>Selected Colors:</span>
                                {color.map((c, index) => (
                                    <span
                                        key={index}
                                        className="flex items-center bg-gray-200 text-sm px-2 py-1 rounded-full"
                                    >
                                        {c}
                                        <button
                                            onClick={() => {
                                                const updatedColors = color.filter((_, i) => i !== index);
                                                setColor(updatedColors);
                                                setTableData(prev => ({
                                                    ...prev,
                                                    totalColor: updatedColors.length
                                                }));
                                            }}
                                            className="ml-2 text-red-600 hover:text-red-800 font-bold focus:outline-none"
                                            title="Remove color"
                                        >
                                            ✕
                                        </button>
                                    </span>
                                ))}
                            </div>
                        )}


                    </div>

                </div>
            </div>
        </div>
    );
};